import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getAccountDetails } from '../../../../actions/adminActions';

import UserEntitlementAccountList from './UserEntitlementAccountList';
import EntitlementListBox from '../../EntitlementListBox';

class UserEntitlements extends Component {
  static propTypes = {
    activeEntitlement: PropTypes.instanceOf(Object),
    activeAccounts: PropTypes.instanceOf(Array),
    accounts: PropTypes.instanceOf(Array),
    updatedEntitlement: PropTypes.func,
  };
  static defaultProps = {
    activeEntitlement: {},
  };

  state = {
    accounts: [],
    activeEntitlements: {},
    entitlements: '',
    hasAccounts: true,
    availableEntitlements: {},
    fetchEntitlement: true,
    activeAccountId: '',
  };

  UNSAFE_componentWillMount() {
    this.getUserEntitlements();
  }
  getUserEntitlements = () => {
    const response = this.props.activeEntitlement;
    const activeAccounts = this.props.activeAccounts;
    const allAccounts = this.props.accounts;
    if (_.isEmpty(activeAccounts)) {
      this.setState({ hasAccounts: false });
    } else {
      const entitlements = response ? _.groupBy(response, 'accountId') : {};
      const accounts = [];
      allAccounts.map(account => {
        const { accountId, accounType, publicId } = account;
        const activeAccount = _.filter(
          activeAccounts,
          item => item.accountId === accountId
        );
        const accountName =
          account.accountType === 'TPP'
            ? account.accountName + ' (Third Party)'
            : account.accountName;
        const selected = activeAccount.length > 0;
        if (selected) {
          accounts.push({
            accountId,
            accountName,
            publicId,
          });
        }
        return null;
      });
      this.setState({
        accounts,
        entitlements,
        hasAccounts: true,
        activeEntitlements: entitlements,
      });
    }
  };

  handleAccountChange = (accountId, publicId) => {
    this.setState(
      {
        fetchEntitlement: true,
        activeAccountId: accountId,
      },
      () => {
        const availableEntitlements = _.cloneDeep(
          this.state.availableEntitlements
        );
        if (
          !this.state.availableEntitlements[accountId] &&
          _.isEmpty(this.state.availableEntitlements[accountId])
        ) {
          getAccountDetails(publicId).then(response => {
            if (response) {
              availableEntitlements[accountId] = response.entitlements || [];
              this.setState({
                availableEntitlements,
                fetchEntitlement: false,
              });
            }
          });
        }
      }
    );
  };

  updateSelectedItems = activeEntitlements => {
    const { activeAccountId } = this.state;
    const newActiveEntitlements = _.cloneDeep(this.state.activeEntitlements);
    newActiveEntitlements[activeAccountId] = activeEntitlements;
    this.setState({ activeEntitlements: newActiveEntitlements }, () => {
      const activeEntitlementItems = [];
      const activeEntitlement = [];

      Object.keys(this.state.activeEntitlements).map(item => {
        this.state.activeEntitlements[item].map(entitlement => {
          activeEntitlement.push(entitlement.id);
          return false;
        });
        return false;
      });

      Object.keys(this.state.availableEntitlements).map(item => {
        this.state.availableEntitlements[item].map(entitlement => {
          const hasKey = activeEntitlement.includes(entitlement.id);
          if (hasKey) {
            activeEntitlementItems.push(entitlement);
          }
          return false;
        });
        return false;
      });

      const groupedEntitlements = _.cloneDeep(newActiveEntitlements);
      const groupedActiveEntitlements = _.groupBy(
        activeEntitlementItems,
        'accountId'
      );
      if (
        groupedActiveEntitlements[activeAccountId] &&
        groupedActiveEntitlements[activeAccountId].length > 0
      ) {
        groupedEntitlements[activeAccountId] =
          groupedActiveEntitlements[activeAccountId];
      } else {
        groupedEntitlements[activeAccountId] = [];
      }
      _.map(activeEntitlementItems, item => {
        if (item.accountId !== activeAccountId) {
          const hasRole = _.filter(
            groupedEntitlements[item.accountId],
            rl => rl.id === item.id
          );
          if (_.isEmpty(hasRole)) {
            groupedEntitlements[item.accountId] = [
              ...groupedEntitlements[item.accountId],
              item,
            ];
          }
        }
      });

      let updatedEntitlements = [];
      Object.keys(groupedEntitlements).map(ac => {
        updatedEntitlements = [
          ...updatedEntitlements,
          ...groupedEntitlements[ac],
        ];
        return false;
      });

      this.props.updatedEntitlement(updatedEntitlements);
    });
  };

  renderEntitlementBox = () => {
    const {
      availableEntitlements,
      activeEntitlements,
      fetchEntitlement,
      activeAccountId,
    } = this.state;
    let renderEntitlementBox = '';
    if (
      _.isEmpty(availableEntitlements[activeAccountId]) &&
      !fetchEntitlement
    ) {
      renderEntitlementBox = (
        <div className="accounts-role-users user-entitlement-box">
          <div className="no-entitlement padding-20">
            No Entitlement assigned to this account!
          </div>
        </div>
      );
    } else if (!_.isEmpty(availableEntitlements[activeAccountId])) {
      renderEntitlementBox = (
        <div className="accounts-role-users user-entitlement-box">
          <EntitlementListBox
            entitlements={availableEntitlements[activeAccountId]}
            activeEntitlements={activeEntitlements[activeAccountId]}
            updateSelectedItems={this.updateSelectedItems}
            clearUsers={false}
            activeAccountId={activeAccountId}
          />
        </div>
      );
    }
    return renderEntitlementBox;
  };

  render() {
    const { accounts, entitlements, hasAccounts } = this.state;
    let rendercontent = <div>loading...</div>;
    if (_.isEmpty(accounts) && !hasAccounts) {
      rendercontent = <div className="no-accounts">No Account assigned.</div>;
    } else if (!_.isEmpty(accounts)) {
      rendercontent = (
        <div>
          <UserEntitlementAccountList
            entitlements={entitlements}
            handleAccountChange={this.handleAccountChange}
            accounts={accounts}
          />
          {this.renderEntitlementBox()}
        </div>
      );
    }
    return (
      <div className="user-roles user-teams">
        <div className="accounts-role--details">{rendercontent}</div>
      </div>
    );
  }
}

export default UserEntitlements;
